import * as React from 'react';

import * as styles from './styles.css';

export function CardActionsLayout(props: React.PropsWithChildren<{}>): React.JSX.Element {
  return <div className={styles['container']}>{props.children}</div>;
}
